import fetcher from "@utils/Fetcher";
import useSWR from "swr";

export const useNews = (categoryId, config) => {
    const key = categoryId ? `news?category_id=${categoryId}` : "news";
    return useSWR(key, fetcher, config);
};

export const useNewsById = (id, config) => {
    return useSWR(`news/${id}`, fetcher, config);
};

export const useNewsCategories = (config) => {
    return useSWR("news_category", fetcher, config);
};
